import VideoController from './videoController';
class HTML5VideoController extends VideoController {
  getPlayerType() {
    return 'html5';
  }
  isSupported(videoElement) {
    return videoElement.tagName === 'VIDEO';
  }
  createPlayer(video) {
    var productMediaWrapper = video.container.closest('[data-product-single-media-wrapper]');
    var enableLooping = productMediaWrapper.dataset.enableVideoLooping;
    video.player = new Shopify.Plyr(video.element, {
      loop: {
        active: enableLooping
      }
    });
  }
  pauseVideo(video) {
    if (video.player.pause) {
      video.player.pause();
    }
  }
  playVideo(video) {
    if (video.player.play) {
      video.player.play();
    }
  }
}
new HTML5VideoController();